import { render } from "./Paging.vue?vue&type=template&id=9bfdd726&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=js"
export * from "./Paging.vue?vue&type=script&lang=js"

import "./Paging.vue?vue&type=style&index=0&id=9bfdd726&lang=css&scoped=true"

import exportComponent from "/media/doevent/Data/doevent/project/pmb/db/de-db-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfdd726"]])

export default __exports__